import React from 'react'
import { Box, Button } from '@mui/material'
import images from 'assets/images'
import { URL_HOME } from 'helpers/config'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import SignUpTribeForm from 'components/pages/signup/SignUpTribeForm'
import HighlightChip from 'components/HighlightChip'
import SignupTemplate from 'components/templates/SignupTemplate'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import FullScreenLoading from 'components/ui/FullScreenLoading'

const advantages: Advantage[] = [
  {
    image: images.signUpTribe.A,
    alt: 'Low-code and fully customizable',
    title: '<strong>Low-code</strong> and fully customizable',
    text: 'White-label the discounts/perks platform for your community, fostering your brand further.',
  },
  {
    image: images.signUpTribe.B,
    alt: 'Add and manage your own perks',
    title: 'Add and manage your <strong>own</strong> perks',
    text: '<strong>Add your own perks</strong> in a private space just for your member companies.',
  },
  {
    image: images.signUpTribe.C,
    alt: 'All-in-one perk dashboard',
    title: '<strong>All-in-one</strong> perk dashboard',
    text: 'Consolidate all discounts and perks <strong>in one dashboard</strong> seamlessly.',
  },
]

const SignUpTribe: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  if (loading) return <FullScreenLoading />

  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="30px" />

          <Box>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">NachoNacho Tribes</h2>
            <h2 className="text-blue fs-32 fw-700 m-0">B2B SaaS discounts for your members</h2>
          </Box>

          <Box my="16px">
            <HighlightChip fontSize="14px">
              800+ perks and <strong>$4.5 million in savings</strong>
            </HighlightChip>
          </Box>

          <Box height="54px" />

          <AdvantagesContainer advantages={advantages} />

          <Box height="41px" />

          <Button href={`${URL_HOME}/seller-meeting`} variant="text" className="fs-14 text-blue">
            Request a video call
            <KeyboardArrowRightIcon className="blue" fontSize="small" sx={{ ml: '3px' }} />
          </Button>
        </>
      }
      right={<SignUpTribeForm />}
    />
  )
}

export default SignUpTribe
